
export function f_bien_bon(text) {
    return `


    <div class=WordSection1>

    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>Bon</span></i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>&nbsp;and&nbsp;<i>bien</i>&nbsp;are often confused because they
    have somewhat similar meanings and they can both be adjectives,&nbsp;<a
    href="https://www.thoughtco.com/introduction-to-french-adverbs-1368802"><span
    style='color:#0086A6'>adverbs</span></a>, or nouns. See the summary table at
    the bottom.</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828'>Adjectives</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>Bon</span></i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>&nbsp;is usually an&nbsp;<a
    href="https://www.thoughtco.com/introduction-to-french-adjectives-1368789"><span
    style='color:#0086A6'>adjective</span></a>. It modifies a noun and means&nbsp;<i>good</i>,&nbsp;<i>suitable</i>,&nbsp;<i>efficient</i>,&nbsp;<i>correct</i>,&nbsp;<i>useful</i>,
    etc.&nbsp;<i>Bien</i>&nbsp;means&nbsp;<i>good</i>,&nbsp;<i>moral</i>,&nbsp;<i>right</i>,&nbsp;<i>healthy</i>,
    etc., and can only be used as an adjective with copular (state-of-being) verbs
    such as&nbsp;<a href="https://www.thoughtco.com/french-verb-etre-1368842"><i><span
    style='color:#0086A6;text-decoration:none'>&ecirc;tre</span></i></a>.</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      est bon étudiant.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      He is a good student.</span></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      est bien comme étudiant.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>He
      is a good student.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>J'ai
      passé une bonne soirée.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I
      had a nice evening.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Ça
      serait bien !</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      That would be good!</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      a bon c&#339;ur.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      He has a good/kind heart.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Tr&egrave;s
      bien !</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      Very good!</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Ce
      timbre n'est pas bon.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>This
      stamp is not valid.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Je
      suis bien partout.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      I'm at ease anywhere.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Luc
      est bon pour le service.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Luc
      is fit for (military) service.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Ce
      n'est pas bien de dire ça.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>It's
      not nice to say that.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Je
      le trouve bien.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      I think it's nice.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828'>Adverbs of Manner</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>Bien</span></i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>&nbsp;is usually an&nbsp;<a
    href="https://www.thoughtco.com/french-adverbs-of-manner-4084830"><span
    style='color:#0086A6'>adverb</span></a>. It means&nbsp;<i>well</i>&nbsp;or can
    be used to stress something.&nbsp;<i>Bon</i>, in the rare instances where it is
    used as an adverb, means&nbsp;<i>good</i>&nbsp;or&nbsp;<i>pleasant</i>.</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>J'ai
      bien dormi.</span></i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      I slept well.</span></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      fait bon ici.</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      It's nice/pleasant here.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      se porte bien.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      He is in good health.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      fait bon vivre.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      It's good to be alive.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Je
      vais bien, merci.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      I am well, thank you.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Il
      fait bon étudier.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      It's good to study.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>La
      radio ne marche pas bien.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>The
      radio isn't working right.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Ça
      sent bon !</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      That smells good!</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>Je
      le vois bien souvent.</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      </span><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>I
      see him quite often.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>J'ai
      bien dit ça.</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      I *did* say that.</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'></td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><span style='font-size:16.5pt;font-family:"Helvetica",sans-serif;
    color:#282828'>Nouns</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white;vertical-align:
    baseline'><i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>Bon</span></i><span style='font-size:13.0pt;font-family:"Georgia",serif;
    color:#282828'>&nbsp;can be a&nbsp;<a
    href="https://www.thoughtco.com/introduction-french-nouns-1368884"><span
    style='color:#0086A6'>noun</span></a>&nbsp;that refers to any sort of important
    or official piece of paper:&nbsp;<i>form</i>,&nbsp;<i>bond</i>,&nbsp;<i>coupon</i>,&nbsp;<i>voucher</i>,
    etc.&nbsp;<i>Bien</i>&nbsp;means&nbsp;<i>good</i>&nbsp;in the general sense,
    and&nbsp;<i>biens</i>&nbsp;means&nbsp;<i>goods</i>&nbsp;(as opposed to
    services).</span></p>
    
    <table class=MsoNormalTable border=0 cellspacing=0 cellpadding=0
     style='border-collapse:collapse'>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon &agrave; vue</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      demand note</span></p>
      </td>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-left:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>le
      bien public</span></i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      public good</span></p>
      </td>
     </tr>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
      padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon de caisse</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      cash voucher</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>le
      bien et le mal</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      good and evil</span></p>
      </td>
     </tr>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
      padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon de commande</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      order form</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>dire
      du bien de</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      to speak well of</span></p>
      </td>
     </tr>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
      padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon de livraison</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      delivery slip</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>faire
      du bien &agrave; quelqu'un</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      to do someone good</span></p>
      </td>
     </tr>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
      padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon de réduction</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      coupon</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>les
      biens d'un magasin</span></i><span lang=FR style='font-size:13.0pt;
      font-family:"Times New Roman",serif'><br>
      a store's goods</span></p>
      </td>
     </tr>
     <tr>
      <td colspan=2 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
      padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span lang=FR style='font-size:13.0pt;font-family:"Times New Roman",serif'>un
      bon du Trésor</span></i><span lang=FR style='font-size:13.0pt;font-family:
      "Times New Roman",serif'><br>
      Treasury bond</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>biens
      immobiliers</span></i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'><br>
      real estate</span></p>
      </td>
     </tr>
     <thead>
      <tr>
       <td colspan=3 valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;
       padding:0cm 0cm 0cm 0cm'>
       <p class=MsoNormal align=center style='margin-bottom:0cm;margin-bottom:.0001pt;
       text-align:center;line-height:normal'><b><span style='font-size:13.0pt;
       font-family:"Times New Roman",serif'>En résumé</span></b></p>
       </td>
      </tr>
     </thead>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'></td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Bon</span></i></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><i><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>Bien</span></i></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>adjective</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>good</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>well</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>adverb</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>nice</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>well</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid #D8D8D8 1.0pt;border-top:none;padding:
      0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>noun</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>form,
      bond</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid #D8D8D8 1.0pt;
      border-right:solid #D8D8D8 1.0pt;padding:0cm 0cm 0cm 0cm'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:13.0pt;font-family:"Times New Roman",serif'>good(s)</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal>&nbsp;</p>
    
    </div>



`;
}